module.exports = __webpack_public_path__ + "static/media/phone-with-app.ab84c9f3.png";